import { FC } from 'react';
import { Action } from 'store/clients/clientsSlice';
import { useAppSelector } from 'store/hooks';

import style from './actionMessage.module.scss';

const getActionMessage = ({
  action,
  totalNumber,
  percentageOfTotal
}: {
  action: Action;
  totalNumber: number;
  percentageOfTotal: number;
}) => {
  const roundedPercentageOfTotal =
    percentageOfTotal === 0 ? percentageOfTotal : Math.round(percentageOfTotal * 100) / 100;

  switch (action) {
    case 'RUN_THE_LIST':
      return `${totalNumber} client(s) need your review. That's ${roundedPercentageOfTotal}% of your list`;
    case 'ENGAGE':
      return `${totalNumber} client(s) need your engagement. That's ${roundedPercentageOfTotal}% of your list`;
    case 'MPI':
      return `${totalNumber} client(s) need to meet you. That's ${roundedPercentageOfTotal}% of your list`;
    case 'OUTREACH':
      return `${totalNumber} client(s) need your outreach`;
    case 'SUPPORT':
      return `${totalNumber} client(s) need your support. That's ${roundedPercentageOfTotal}% of your list`;
  }
};

const ActionMessage: FC = () => {
  const { clientsList, filters } = useAppSelector((state) => state.clients);
  const { totalNumber } = clientsList;

  const actionMessage =
    clientsList.totalNumber && clientsList.percentageOfTotal && filters.action
      ? getActionMessage({
          action: filters.action,
          totalNumber: clientsList.totalNumber,
          percentageOfTotal: clientsList.percentageOfTotal
        })
      : null;

  return <div className={style.found}>{actionMessage ?? `${totalNumber} clients found`}</div>;
};

export default ActionMessage;
